import {ToggleGroupListType} from '@/components/commons/toggle-group-list-type/ToggleGroupListType'

export const InputSelectUserListType = ({
    listType,
    setListType
}: {
    listType: 'team' | 'all'
    setListType: (listType: 'team' | 'all') => void
}) => {
    return (
        <ToggleGroupListType
            listType={listType}
            setListType={setListType}
            radioList={{
                team: {label: 'commons:team', value: 'team'},
                all: {label: 'commons:view_all', value: 'all'}
            }}
        />
    )
}
